export const SET_BANK_DATA = 'SET_BANK_DATA'
export const SET_BANK_DATA_NOT_ALLOWED = 'SET_BANK_DATA_NOT_ALLOWED'
export const SET_BANK_DATA_REQUEST_STATUS = 'SET_BANK_DATA_REQUEST_STATUS'
export const RESET_BANK_DATA = 'RESET_BANK_DATA'
